
import PropTypes from 'prop-types';
import { useLayoutEffect, useState } from 'react';

import { LS_DARK_MODE } from '../../../config';
import HeaderBreadcrumb from '../HeaderBreadcrumb';
import HeaderNavActions from '../HeaderNavActions';
import HeaderNavigation from '../HeaderNavigation';

import * as style from './style.module.css';

const getBodyClass = (savedTheme) => {
  if (savedTheme === 'DARK') return 'dark';
  if (savedTheme === 'AUTO') return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  return 'light';
};

const Header = ({
  history = [],
  actions = [],
  contests = [],
  contestsToJudge = [],
  user = null,
  allowedActions = [],
  unreadChats = 0,
  unreadNotifications = 0,
  easterGameScore = null,
  loading = false,
  isKeyboardOpened = false,
  isHomepage = false,
  onSignOut = () => { },
  onLanguageChange = () => { }
}) => {
  const [theme, setTheme] = useState(localStorage.getItem(LS_DARK_MODE) || 'AUTO');

  useLayoutEffect(() => {
    if (document.body) {
      document.body.className = getBodyClass(theme);
    }

    if (theme === 'AUTO') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = () => {
        if (document.body) {
          document.body.className = getBodyClass('AUTO');
        }
      };
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
  }, [theme]);

  const handleThemeChange = (newTheme) => {
    localStorage.setItem(LS_DARK_MODE, newTheme);
    setTheme(newTheme);
  }

  const handleLanguageChange = () => {
    if (!loading) {
      onLanguageChange();
    }
  }

  const props = {
    contest: contests.length > 0 ? contests[0] : null,
    contestsToJudge,
    user,
    allowedActions,
    unreadChats,
    unreadNotifications,
    easterGameScore,
    loading,
    darkModeStatus: theme,
    history,
    actions,
    onSignOut,
    onLanguageChange: handleLanguageChange,
    onThemeChange: handleThemeChange,
  }

  return (
    <>
    <header className={`${style.header} ${!isHomepage ? style.headerWithBreadcrumb : ''}`}>
      <HeaderNavigation {...props} className={style.primaryNav}/>
      <HeaderBreadcrumb {...props} className={style.breadcrumbNav} />
    </header>
    <nav className={`${style.bottomBarMobile} ${!isHomepage ? style.headerWithBreadcrumb : ''} ${isKeyboardOpened ? style.keyboardOpen : ''}`}>
      <HeaderNavActions {...props} />
    </nav>
    </>
  );
};

export default Header;

Header.propTypes = {
  t: PropTypes.func,
};
